import { render } from "./BranchesDashboard.vue?vue&type=template&id=24cdc160&scoped=true"
import script from "./BranchesDashboard.vue?vue&type=script&lang=js"
export * from "./BranchesDashboard.vue?vue&type=script&lang=js"

import "./BranchesDashboard.vue?vue&type=style&index=0&id=24cdc160&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cdc160"]])

export default __exports__